
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { baseCalculateParams, totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { PaymentRelatedTypesKeys, relatedTypesInversed } from '@teinor/erp/types/company/config/paymentType'
import { HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { useCallback, useMemo, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ButtonDisabledOrLoader, ButtonSecondary } from '../../../../../../baseComponents/Button'
import { CalculateParamsTy } from '../../../../../../baseComponents/Displays/DisplayPrice/types'
import { ModalMediumCenteredLoading } from '../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import TwinForm from '../../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../../forms/TwinForm/types'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { useGetDictPaymentBanksTPV } from '../../../../../../utils/hooks/payments/getDictPaymentBanks'
import { SetEditDeleteModalTy, UseEditDeleteModalProps } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { getPreparePricesConfigParam } from '../../../../../../utils/reducers/getters'
import { PaymentTypesPayload } from '../../../../../../utils/reducers/payments/paymentTypes'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { parseOrderTableData } from '../../../OrderQuoteLayout/function'
import { TPVOrderData } from '../../types'
import CustomInputTotalsTablePriceTPV from '../CustomInputTotalsTable'
import PaymentMethodsTypesBoxTPV from './PaymentMethodsTypesBoxTPV'
import { PaymentTypeModelAddExtendedTPV, TotalPaymentsTPV, TPVHookBaseFunctionTy, TPVHookComponentFunctionTy, TPVTotalPaymentsCompleteTy } from './types'
import { SwitchButton, TabItems } from '../../../../../../baseComponents/Button/SwitchButton'
import { InputCalendarStateFull } from '../../../../../../forms/Input/InputCalendar'
import './basePaymentMethodTPV.sass'
import { invoiceTypeInversed, sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import useGetSellticketCustomerVouchers from '../../../../../../utils/hooks/sells/orders/useGetSellTicketCustomerVouchers'
import Checkbox from '../../../../../../forms/Checkbox'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { TwinIconToolTip } from '../../../../../../baseComponents/TwinIcon'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'

type BasePaymentMethodsTPVProps = BasePaymentMethodsTPVLogicProps & ReduxBasePaymentMethodsTPV & {
    setOpenModal: SetEditDeleteModalTy
    openModal?: UseEditDeleteModalProps
    url: string
    isReadOnly?: boolean
    hookComponentsFuntion: TPVHookComponentFunctionTy
    hookBaseFuntion: TPVHookBaseFunctionTy
    onSubmit?: () => void
    translations: {
        textButton: string
        textTotal: string
    },
    allRowData?: RowData
}

const BasePaymentMethodsTPV: React.FC<BasePaymentMethodsTPVProps> = ({ url, completeData, paymentTypes, setOpenModal, hookComponentsFuntion, hookBaseFuntion, onSubmit, tableData, translations, allRowData, isRefund, isReservedRefund }) => {
    const { dictPaymentBanks, myPaymentMethodsTypes, handleChangeField, myTotalPayments, setMyTotalPayments, handleOnBlurTotals, checkAllOk, totalsByTypes, changeTab, handleReservedDate, dictVouchers, handleMarkAsInvoice } = useBasePaymentMethodsTPVLogic({ completeData, paymentTypes, tableData, isReservedRefund, isRefund })
    const { handleBeforeSubmit, handleOnSubmit, loading, handleErrors } = hookBaseFuntion({ completeData, setOpenModal, onSubmit, checkAllOk, myTotalPayments: myTotalPayments.myTotalPayments, allRowData, isReservedRefund })
    const renderThis: JSX.Element[] = []

    for (const key in myPaymentMethodsTypes || []) {
        const element = myPaymentMethodsTypes?.[key]
        if (element) {
            renderThis.push(<PaymentMethodsTypesBoxTPV element={element} rowIndex={parseInt(key)} handleChangeField={handleChangeField} completeData={completeData} myTotalPayments={myTotalPayments} dictPaymentBanks={dictPaymentBanks} key={key} setMyTotalPayments={setMyTotalPayments} hookFuntion={hookComponentsFuntion} handleOnBlurTotals={handleOnBlurTotals} totalsByTypes={totalsByTypes} dictVouchers={dictVouchers} />)
        }
    }
    return (
        <ModalMediumCenteredLoading loading={myPaymentMethodsTypes ? false : true} className='modal_order_payment_method_tpv ' opened={true} setOpened={() => setOpenModal(null)} onClickOut={false}>
            <div className='flex flex-col px-30 pt-30'>
                <div className='flex items-center'>
                    <h2 className='text-left'><TwinTrans transKey='paymentMethods'>Métodos de pago</TwinTrans></h2>
                    {!isRefund ? <PaymentMethodSwitchButton {...{ changeTab, activeTab: myTotalPayments.myTotalPayments.partialCharge ? 1 : 0, handleReservedDate, myTotalPayments: myTotalPayments.myTotalPayments }} /> : null}
                </div>
                <InvoiceTicketComponent {...{ myTotalPayments, isRefund, handleMarkAsInvoice, completeData}} />
                <div className='mt-30 w-full py-20 px-30 border border-gray-D6 bg-gray-FB payment_box'>
                    <CustomInputTotalsTablePriceTPV currency={completeData?.header?.CurrencyId || 'EUR'} inputName={translations.textTotal} value={myTotalPayments.myTotalPayments.total} className='medium16' classNameValue='regular26' />
                </div>
            </div>
            <TwinForm action={url} onSubmit={handleOnSubmit} className='mt-20 flex flex-auto flex-col notFlexAutoFormRender' beforeSubmitHandler={handleBeforeSubmit} onError={handleErrors}>
                <div className='flex flex-col px-30 flex-auto gap-10 overflow-auto h-1'>
                    {renderThis}
                </div>
                <PaymentMethodTotals completeData={completeData} myTotalPayments={myTotalPayments.myTotalPayments} setOpened={() => setOpenModal(null)} loading={loading || false} textButton={translations.textButton} partialCharge={myTotalPayments.myTotalPayments.partialCharge} />
            </TwinForm>
        </ModalMediumCenteredLoading>
    )
}

interface BasePaymentMethodsTPVLogicProps {
    completeData: TPVOrderData
    paymentTypes: PaymentTypesPayload
    tableData: OrderTableData
    isReservedRefund?: boolean
    isRefund?: boolean
}

export interface TotalByPaymentTypes {
    total: number,
    byPaymentType: TwinDictionary
}

const useBasePaymentMethodsTPVLogic = ({ completeData, paymentTypes, tableData, isReservedRefund, isRefund }: BasePaymentMethodsTPVLogicProps) => {
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const headerDataCalculate: HeaderDataCalculate = {
        OrderCosts: [],
        ParamsRoundingDecimals: calculateParams,
        total_recharge_after: completeData?.header?.total_recharge_after,
        OrderShipping: {} as any,
        isFinished: completeData?.header?.isFinished,
        OrderAccounts: []
    }
    const totalsOrderTableData = parseOrderTableData(tableData as any, headerDataCalculate)
    const paymentTPVTypesMemo = useMemo(() => {
        const TpvPaymentTypes: TwinDictionary = {}
        for (const key in paymentTypes?.activeTpv) {
            const element = paymentTypes?.activeTpv?.[parseInt(key)]
            if (element?.active) {
                TpvPaymentTypes[element.id] = element
            }
        }
        return TpvPaymentTypes
    }, [paymentTypes])
    
    const [myTotalPayments, setMyTotalPayments] = useState <TPVTotalPaymentsCompleteTy>(() => {
        const myResult: PaymentTypeModelAddExtendedTPV[] = []
        const dictCashRegisterMoneyLogs: TwinDictionary = {}
        for (const element of completeData.header?.CashRegisterMoneys) {
            if (!dictCashRegisterMoneyLogs[element.PaymentTypeId]) {
                dictCashRegisterMoneyLogs[element.PaymentTypeId] = []
            }
            dictCashRegisterMoneyLogs[element.PaymentTypeId].push(element)
        }
        const dictQuantity: TwinDictionary = {}
        for (const key in paymentTPVTypesMemo) {
            const element = paymentTPVTypesMemo[parseInt(key)]
            const paymentTypeData = dictPaymentTypesTPV?.[paymentTPVTypesMemo[element.id]?.relatedType as PaymentRelatedTypesKeys]
            for (const moneyLogs of dictCashRegisterMoneyLogs?.[element.id] || []) {
                if (moneyLogs?.CashRegisterMoneyLogs) {
                    for (const log of moneyLogs.CashRegisterMoneyLogs) {
                        if (!dictQuantity[element.id]) {
                            dictQuantity[element.id] = 0
                        }
                        dictQuantity[element.id] = dictQuantity[element.id] + parseFloat(log.money)
                    }
                }
            }
            myResult.push({
                ...element,
                PaymentTypeId: element.id,
                quantity: 0,
                payment_data: paymentTypeData?.extraProps?.value,
                assigned: false,
                quantityPayed: dictQuantity[element.id] 
            })
        }
        const byPaymentType: TwinDictionary = {}
        for (const key in paymentTPVTypesMemo) {
            let myTotal = completeData?.header?.total_to_pay || totalsOrderTableData.totals.total
            if (isReservedRefund) {
                myTotal = completeData?.header?.total_payed || 0
            } else if (isRefund) {
                myTotal = totalsOrderTableData.totals.total
            }
            byPaymentType[key] = myTotal
        }
        const totalsByTypes = {
            total: 0,
            byPaymentType
        }
        let myTotalPayments = {
            total: totalsOrderTableData.totals.total,
            totalAssigned: completeData?.header?.total_payed || 0,
            total_payed: completeData?.header?.total_payed,
            total_to_pay: completeData?.header?.total_to_pay,
            pendingAssigned: completeData?.header?.total_to_pay || totalsOrderTableData.totals.total,
            changeDict: { } as any,
            errors: parseFloat(String(totalsOrderTableData.totals.total)) !== 0 ? { 'totals': true } : null,
            myPaymentMethodsTypes: dictionaryComplexFromJsonArr(myResult, 'order'),
            partialCharge: false,
            reservedDate: completeData?.header?.reservedDate,
            invoiceType: completeData?.header?.invoiceType || invoiceTypeInversed['ticket'],
        }
        if (isReservedRefund) {
            myTotalPayments.total = completeData?.header?.total_payed
            myTotalPayments.totalAssigned = 0
            myTotalPayments.pendingAssigned = completeData?.header?.total_payed
            myTotalPayments.errors = {'totals': true }
        } else if (isRefund) {
            myTotalPayments.totalAssigned = 0
            myTotalPayments.pendingAssigned = totalsOrderTableData.totals.total
        }
        return {
            myTotalPayments,
            totalsByTypes,
            voucherData: {
                selectedVouchers: [],
                vouchers: [],
                totalVouchers: 0
            }
            
        }
    })
    const { dictPaymentBanks } = useGetDictPaymentBanksTPV({ CustomerId: completeData?.header?.CustomerId, WorkingCenterId: completeData?.header.BillingWorkingCenterId, WorkingCenterStationId: completeData?.header?.WorkingCenterStationId})
    const { dictVouchers } = useGetSellticketCustomerVouchers({ CustomerId: completeData?.header?.CustomerId, SellTicketId: completeData?.header?.id})
    const dictPaymentTypesTPV: Record<PaymentRelatedTypesKeys, { hasPaymentData: boolean, extraProps?: TwinDictionary }> | null = useMemo(() => {
        return {
            0: { hasPaymentData: false },
            1: {
                hasPaymentData: true,
                extraProps: { items: dictPaymentBanks?.customerBanks?.items || {}, value: dictPaymentBanks?.customerBanks?.defaultId }
            },
            2: {
                hasPaymentData: true,
                extraProps: { items: dictPaymentBanks?.workingCenterBanks?.items || {}, value: dictPaymentBanks?.workingCenterBanks.defaultId, }
            },
            3: { hasPaymentData: false },
            4: { hasPaymentData: false },
            5: { hasPaymentData: false },
            6: {
                hasPaymentData: true,
                extraProps: { items: dictPaymentBanks?.workingCenterShift4Devices?.items || {}, value: dictPaymentBanks?.workingCenterShift4Devices.defaultId }
            },
            7: { hasPaymentData: false },
        }
    }, [dictPaymentBanks])

    const { t } = useTwinTranslation()
    const completeInfoPaymentErr = t('setAllPaymentInformation', 'Debes configurar toda la información de pago')
    const quantitNoMatchErr = t('quantitiesNotMatchTotal', 'Las cantidades no cuadran con el total')
    const noCustomerInfo = t('noCustomerInfo', 'No tienes toda la información requerida del cliente')

    const checkAllOk: BeforeSubmitHandler = useCallback((vals) => {
        vals.invoiceType = myTotalPayments?.myTotalPayments?.invoiceType
        const isInvoiceTypeAlready = completeData?.header?.invoiceType === invoiceTypeInversed['invoice']
        if (!isInvoiceTypeAlready && (myTotalPayments?.myTotalPayments?.invoiceType === invoiceTypeInversed['invoice'])) {
            if (!myTotalPayments?.myTotalPayments?.customerInfo) {
                changeErrorMessage(noCustomerInfo)
                return false
            }
        }
        let totalCalculated = 0
        const copyMyPaymentMethodsTypes = JSON.parse(JSON.stringify(myTotalPayments?.myTotalPayments.myPaymentMethodsTypes))
        const myPaymentMethodDates = []
        for (const key in copyMyPaymentMethodsTypes) {
            const element = copyMyPaymentMethodsTypes[parseInt(key)]
            if (parseFloat(element.quantity)) {
                totalCalculated += parseFloat(String(element.quantity))
                const relatedType = paymentTPVTypesMemo[element?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys
                const myDictPaymentTypes = dictPaymentTypesTPV?.[relatedType]
                const hasPaymentData = myDictPaymentTypes?.hasPaymentData
                const extraProps = myDictPaymentTypes?.extraProps
                if (extraProps?.items) {
                    const payment_data = element.payment_data ? extraProps?.items?.[element.payment_data] : extraProps?.items?.[myDictPaymentTypes?.extraProps?.value]
                    if (payment_data) {
                        element.new_extra_payment_data = {
                            iban: payment_data?.iban,
                            name: payment_data?.name,
                            id: payment_data?.id,
                            manufacturer: payment_data?.manufacturer, 
                            serialNumber: payment_data?.serialNumber,
                        }
                    }
                } else {
                    if ((!isRefund && !isReservedRefund) && (relatedType === relatedTypesInversed['voucher'])) {
                        const myVoucherData = []
                        let voucherQuantity = 0
                        for (const voucher of myTotalPayments?.voucherData?.vouchers || []) {
                            if (voucher?.id || voucher.voucherNumber) {
                                myVoucherData.push({ id: voucher.id, voucher_n: voucher.voucherNumber, amount: voucher.quantity })
                                voucherQuantity = roundNumberAndDecimals(voucherQuantity + parseFloat(String(voucher.quantity)), totalCalculateParams)
                            }
                        }
                        if (parseFloat(element.quantity) <= voucherQuantity) {
                            if (myVoucherData?.length) {
                                element.new_extra_payment_data = myVoucherData
                            } else {
                                changeErrorMessage(completeInfoPaymentErr)
                                return false
                            }
                        } else {
                            changeErrorMessage(quantitNoMatchErr)
                            return false
                        }
                    }
                }
                if (element.quantity && hasPaymentData && (!element.payment_data && !extraProps?.items)) {
                    changeErrorMessage(completeInfoPaymentErr)
                    return false
                }
                if (myTotalPayments?.myTotalPayments?.changeDict && Object.keys(myTotalPayments?.myTotalPayments.changeDict)?.length) {
                    const isCashPaymentType = parseInt(String(element.relatedType)) === relatedTypesInversed['cash']
                    if (isCashPaymentType) {
                        element.new_extra_payment_data = { ...element.new_extra_payment_data, ...myTotalPayments?.myTotalPayments?.changeDict?.[element.id] }
                    }
                }
                element.CurrencyId = element.extraData?.CurrencyId || element.CurrencyId || completeData?.header?.CurrencyId
                myPaymentMethodDates.push(element)
            }
        }
        const totalPayed = completeData?.header?.status === sellTicketStatusInversed['partialCharged'] ? parseFloat(String(myTotalPayments?.myTotalPayments?.total_payed || '0')) : 0
        const parsedTotalCalulated = roundNumberAndDecimals(totalCalculated + totalPayed, baseCalculateParams)
        const notTotalQuantityRefund = isReservedRefund && totalCalculated !== parseFloat(String(myTotalPayments?.myTotalPayments?.total_payed))
        const notTotalQuantity = !isReservedRefund && !myTotalPayments?.myTotalPayments?.partialCharge && (parsedTotalCalulated !== parseFloat(String(totalsOrderTableData.totals.total)))
        if (notTotalQuantityRefund || notTotalQuantity) {
            changeErrorMessage(quantitNoMatchErr)
            return false
        }
        vals.paymentMethodInfo = { ...myPaymentMethodDates }
        vals.partialCharge = myTotalPayments?.myTotalPayments?.partialCharge
        vals.totalAssigned = myTotalPayments?.myTotalPayments?.totalAssigned
        vals.pendingAssigned = myTotalPayments?.myTotalPayments?.pendingAssigned
        vals.reservedDate = myTotalPayments?.myTotalPayments?.reservedDate
        return true
    }, [totalsOrderTableData.totals.total, completeInfoPaymentErr, dictPaymentTypesTPV, paymentTPVTypesMemo, quantitNoMatchErr, completeData?.header?.CurrencyId, myTotalPayments, isReservedRefund, completeData?.header?.status, isRefund, noCustomerInfo, completeData?.header?.invoiceType])

    const recalculateTotals = useCallback((old: TPVTotalPaymentsCompleteTy) => {
        let copyOld = JSON.parse(JSON.stringify(old))
        let totalsTotal = copyOld.myTotalPayments?.total_to_pay || copyOld.myTotalPayments?.total
        if (isReservedRefund) {
            totalsTotal = copyOld.myTotalPayments?.total_payed
        } else if (isRefund) {
            totalsTotal = copyOld.myTotalPayments?.total
        }
        const dictByPaymentTotals: TwinDictionary = {}
        let total = 0
        for (const key in copyOld.myTotalPayments.myPaymentMethodsTypes) {
            const element = copyOld.myTotalPayments.myPaymentMethodsTypes[parseInt(key)]
            const paymentQuantity = parseFloat(String(element?.quantity))
            total = total + paymentQuantity
            dictByPaymentTotals[element.PaymentTypeId] = paymentQuantity
        }
        total = roundNumberAndDecimals(total, totalCalculateParams)
        for (const key in copyOld.totalsByTypes.byPaymentType) {
            copyOld.totalsByTypes.byPaymentType[key] = roundNumberAndDecimals(totalsTotal - (total - dictByPaymentTotals[key]), totalCalculateParams)
        }
        copyOld.totalsByTypes.total = total
        return copyOld
    }, [isReservedRefund, isRefund])

    const handleOnBlurTotals = useCallback(() => {
        setMyTotalPayments((old) => recalculateTotals(old))
    }, [setMyTotalPayments, recalculateTotals])

    const handleChangeField = useCallback((pos: number, field: string, value: any, maxValue?: number) => {
        setMyTotalPayments((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            let myField = field
            let myValue = value
            let recalculateAfter = false
            const PaymentTypeId = copyOld.myTotalPayments.myPaymentMethodsTypes[pos].PaymentTypeId
            if (field === 'autocomplete') {
                myField = 'quantity'
                myValue = maxValue === 0 ? 0 : copyOld.totalsByTypes.byPaymentType[PaymentTypeId]
                if (maxValue && myValue > maxValue) {
                    myValue = maxValue
                }
                recalculateAfter = true
            }
            if (myField === 'quantity') {
                const paymentMethodsTypes = copyOld.myTotalPayments.myPaymentMethodsTypes
                paymentMethodsTypes[pos][myField] = myValue
                const withoutMe = copyOld.myTotalPayments.total - copyOld.totalsByTypes.byPaymentType[PaymentTypeId]
                const myTotal = withoutMe + parseFloat(myValue || 0)
                copyOld.myTotalPayments.totalAssigned = myTotal
                copyOld.myTotalPayments.pendingAssigned = copyOld.myTotalPayments.total - myTotal
                if (copyOld.myTotalPayments.pendingAssigned !== 0) {
                    if (!copyOld.myTotalPayments.errors) {
                        copyOld.myTotalPayments.errors = {}
                    }
                    copyOld.myTotalPayments.errors['totals'] = true
                } else {
                    if (copyOld.myTotalPayments.errors?.['totals']) {
                        delete copyOld.myTotalPayments.errors?.['totals']
                    }
                }
                paymentMethodsTypes[pos]['assigned'] = parseFloat(myValue || 0) ? true : false
            } else {
                const paymentMethodsTypes = copyOld.myTotalPayments.myPaymentMethodsTypes
                if (paymentMethodsTypes) {
                    paymentMethodsTypes[pos][field] = myValue
                }
            }
            if (recalculateAfter) {
                return recalculateTotals(copyOld)
            }
            return copyOld
        })
    }, [setMyTotalPayments, recalculateTotals])

    const changeTab = useCallback((val: number) => {
        setMyTotalPayments((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.myTotalPayments.partialCharge = val === 0 ? false : true
            return copyOld
        })
    }, [setMyTotalPayments])
    
    const handleReservedDate = useCallback((val: string) => {
        setMyTotalPayments((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.myTotalPayments.reservedDate = val
            return copyOld
        })
    }, [setMyTotalPayments])

    const getCustomerInfo = useCallback(async (Customer: TwinDictionary) => {
        let allCustomerInfo = false
        if (Customer) {
            const hasCustomerInfo = Customer?.id_number && Customer
            const items = await twinFetchPostJSON('/api/app/customer/customerAddress/getAllCustomerAddresses', { where: { 'CustomerId': Customer.id, 'fiscal_address': true } })
            if (hasCustomerInfo && items) {
                allCustomerInfo = true
            }
        }
        return allCustomerInfo
    }, [])
    
    const handleMarkAsInvoice = useCallback(async (val: boolean) => {
        let allCustomerInfo = myTotalPayments.myTotalPayments.customerInfo
        if (val && myTotalPayments.myTotalPayments.customerInfo === undefined) {
            allCustomerInfo = await getCustomerInfo(completeData?.header?.Customer)
        }
        setMyTotalPayments((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.myTotalPayments.invoiceType = val ? invoiceTypeInversed['invoice'] : invoiceTypeInversed['ticket']
            if (allCustomerInfo) {
                copyOld.myTotalPayments.customerInfo = true
                delete copyOld.myTotalPayments.errors['customer']
            } else {
                copyOld.myTotalPayments.errors = { ...copyOld.myTotalPayments.errors , 'customer': true }
                copyOld.myTotalPayments.customerInfo = false
                if (copyOld.myTotalPayments.invoiceType === invoiceTypeInversed['ticket']) {
                    delete copyOld.myTotalPayments.errors['customer']
                }
            }
            return copyOld
        })
    }, [setMyTotalPayments, myTotalPayments.myTotalPayments.customerInfo, getCustomerInfo, completeData?.header?.Customer])

    return { checkAllOk, dictPaymentBanks, myPaymentMethodsTypes: myTotalPayments.myTotalPayments.myPaymentMethodsTypes, totalsOrderTableData, handleChangeField, myTotalPayments: myTotalPayments, setMyTotalPayments, handleOnBlurTotals, totalsByTypes: myTotalPayments.totalsByTypes, changeTab, handleReservedDate, dictVouchers, handleMarkAsInvoice }
}


interface PaymentMethodTotalsProps {
    completeData: TPVOrderData
    setOpened: ModalOpenedSetTy
    myTotalPayments: TotalPaymentsTPV
    loading: boolean
    textButton: string
    partialCharge: boolean
}

const PaymentMethodTotals: React.FC<PaymentMethodTotalsProps> = ({ completeData, myTotalPayments, setOpened, loading, textButton, partialCharge }) => {
    const { t } = useTwinTranslation()
    const totalPercentage = (myTotalPayments.totalAssigned / myTotalPayments.total) * 100
    return (
        <div className='flex flex-col mt-20 bg-gray-FB payment_footer'>
            <div className='flex'>
                <div className='flex flex-col flex-auto payment_footer_totals'>
                    <CustomInputTotalsTablePriceTPV currency={completeData?.header?.CurrencyId || 'EUR'} inputName={t('totalAssigned', 'Total asignado') + ':'} value={myTotalPayments.totalAssigned} className='medium16' classNameValue='regular24' />
                    <CustomInputTotalsTablePriceTPV currency={completeData?.header?.CurrencyId || 'EUR'} inputName={t('pending', 'Pendiente') + ':'} value={myTotalPayments.pendingAssigned} className='medium16' classNameValue={'regular24  ' + (myTotalPayments.pendingAssigned === 0 ? '' : 'text_footer_red')} />
                </div>
                <div className='flex items-center gap-x-10 justify-end flex-auto'>
                    {!loading ? <ButtonSecondary onClick={() => setOpened(null)}>
                        <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                    </ButtonSecondary> : null}
                    <ButtonDisabledOrLoader loading={loading} textButton={textButton} buttonIsDisabled={myTotalPayments?.errors && Object.keys(myTotalPayments?.errors).length && (!partialCharge || (partialCharge && myTotalPayments?.errors?.customer)) ? true : false}/>
                </div>
            </div>
            <div className='parent_bar bg-gray-D9 mt-10'>
                <div className='children_bar bg-green-43' style={{ width: (totalPercentage <= 100 ? totalPercentage : '100') + '%' }}></div>
            </div>
        </div>
    )
}

interface PaymentMethodSwitchButtonProps {
    changeTab: (val: number) => void
    handleReservedDate: (val: string) => void
    myTotalPayments: TotalPaymentsTPV
    activeTab: number
}

const PaymentMethodSwitchButton: React.FC<PaymentMethodSwitchButtonProps> = ({ changeTab, activeTab, handleReservedDate, myTotalPayments }) => {
    const { t } = useTwinTranslation()
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'sell'}>Venta</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'reserve'}>Reserva</TwinTrans>
        },
    ]
    return (
        <div className='flex ml-auto items-center'>
            {activeTab === 1 ? <div className='mr-20 input_calendar_payment_method text-left'><InputCalendarStateFull onlyValids={true} label={t('approximateDeliveryDateShort', 'Fecha aproximada entrega')} hideLabel={true} name='reservedDate' onChange={handleReservedDate} value={myTotalPayments.reservedDate} placeholder={t('approxDeliveryDateShort', 'Fecha aprox. entrega')} /></div> : null}
            <SwitchButton className='mr-auto' onClick={changeTab} active={activeTab} items={items} />
        </div>
    )
}

interface InvoiceTicketComponentProps {
    isRefund?: boolean
    myTotalPayments: TPVTotalPaymentsCompleteTy
    completeData: TPVOrderData
    handleMarkAsInvoice: (val: boolean) => Promise<void>
}

const InvoiceTicketComponent: React.FC<InvoiceTicketComponentProps> = ({ isRefund, myTotalPayments, completeData, handleMarkAsInvoice }) => {
    const { t } = useTwinTranslation()
    if (isRefund) {
        return null
    }
    const showErrorMsg = myTotalPayments.myTotalPayments.invoiceType === invoiceTypeInversed['invoice'] && !myTotalPayments.myTotalPayments.customerInfo
    return (
        <div className='mr-auto flex'>
            <Checkbox label={t('doYouWantInvoice', '¿Quieres factura?')} onChange={handleMarkAsInvoice} checked={myTotalPayments.myTotalPayments.invoiceType === invoiceTypeInversed['invoice']} readOnly={completeData?.header?.status !== sellTicketStatusInversed['creating'] && completeData?.header?.status !== sellTicketStatusInversed['saved']} />
            {showErrorMsg ? <TwinIconToolTip positionStrategy='fixed' className='ml-6' icon={faInfoCircle} message={t('customerInfoRequired', 'Se requiere más información del cliente')} id={'invoiceTicket_tooltip'} classNameTooltip='max-w-300' />: null}
        </div>
    )
}


const basePaymentMethodsTPVDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
}

type ReduxBasePaymentMethodsTPV = ConnectedProps<typeof basePaymentMethodsTPVConnect>
const mapBasePaymentMethodsTPVConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes })
const basePaymentMethodsTPVConnect = connect(mapBasePaymentMethodsTPVConnector, basePaymentMethodsTPVDispatch)
const basePaymentMethodsTPVConnectLoading = withLoading(BasePaymentMethodsTPV, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }])
const BasePaymentMethodsTPVConnect = basePaymentMethodsTPVConnect(basePaymentMethodsTPVConnectLoading)
export default BasePaymentMethodsTPVConnect